<template>
  <div>
    <table class="table table-responsive">
      <tbody>
        <tr v-if="status">
          <th style="border-top: none">Status</th>
          <td style="border-top: none">
            <EpcStatus :status="status" />
          </td>
        </tr>
        <tr>
          <th>{{ $t('name') }}</th>
          <td>{{ saveGet(functionType, '-', 'department', 0, 'value') }}</td>
        </tr>
        <tr>
          <th>{{ $t('parent_company') }}</th>
          <td>
            <p v-if="glnType">
              {{ $t(`glnType.${glnType}_text`) }}
              <br />
              {{ saveGet(functionType, '-', 'parentOrganization', 'gln') }}
            </p>
            <p v-else>-</p>
          </td>
        </tr>
        <tr>
          <th>{{ $t('role') }}</th>
          <td>
            <ul style="padding-left: 0" id="v-roles-list">
              <p v-for="role in roles" :key="role.toString() + Math.random()">
                {{ $t(`locationType.${role}_title`) }}
              </p>
            </ul>
          </td>
        </tr>
        <tr>
          <th>{{ $t('more_organizations') }}</th>
          <td>
            <template
              v-if="additionalIDs instanceof Array && additionalIDs.length > 0"
            >
              <p
                v-for="additionalID in additionalIDs"
                :key="additionalID.toString() + Math.random()"
              >
                {{
                  $t(`locationIdType.${additionalID.locationID_Type}_title`)
                }}:
                {{ additionalID.locationID }}
              </p>
            </template>
            <template v-else> - </template>
          </td>
        </tr>
        <tr>
          <th>{{ $t('adress') }}</th>
          <td style="border-bottom: 0">
            <Address
              :show-map="showMap"
              :address="saveGet(functionType, null, 'address', 0)"
            />
          </td>
        </tr>
        <tr>
          <th>{{ $t('contact') }}</th>
          <td style="border-bottom: 0">
            <Contact
              :contact="saveGet(functionType, null, 'contactPoint', 0)"
            />
          </td>
        </tr>
        <links-tr :linkSet="linkSet">{{ $t('targets') }}</links-tr>
        <tr>
          <th>{{ $t('last_update') }}</th>
          <td style="border-bottom: none">{{ dateUpdated }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { saveGet } from '../mixins/saveGet'
import Address from './Address'
import Contact from './Contact'
import moment from 'moment/moment'
import EpcStatus from './EpcStatus.vue'
import LinksTr from '@/components/LinksTr.vue'

export default {
  name: 'FunctionType',
  props: ['functionType', 'showMap', 'status'],
  components: {
    EpcStatus,
    Contact,
    Address,
    LinksTr
  },
  mixins: [saveGet],
  computed: {
    additionalIDs() {
      return this.saveGet(this.functionType, null, 'additionalOrganizationID')
    },
    glnType() {
      return this.saveGet(
        this.functionType,
        null,
        'parentOrganization',
        'glnType'
      )
    },
    roles() {
      return this.saveGetAndMap(
        this.functionType,
        '-',
        arr => arr.filter(x => x),
        'organizationRole'
      )
    },
    dateUpdated() {
      let updated = this.saveGet(this.functionType, '', 'dateUpdated')
      if (!updated) {
        return '-'
      }
      return moment(updated).format('DD. MMM YYYY')
    }
  },
  i18n: {
    messages: {
      de: {
        name: 'Abteilung',
        role: 'Unternehmensrolle',
        parent_company: 'GLN des Mutterunternehmen',
        contact: 'Kontakt',
        last_update: 'Zuletzt geändert',
        adress: 'Adresse',
        more_organizations: 'Weitere Unternehmens-IDs',
        targets: 'Lokationsbezogene Verlinkungen'
      },
      en: {
        name: 'Department',
        role: 'Company role',
        parent_company: ' Parentcompany GLN',
        contact: 'Contact',
        last_update: 'Last update',
        adress: 'Address',
        more_organizations: 'Additional organization-IDs',
        targets: 'Location related links'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FunctionType.vue